import { Avatar, AvatarProps, Tooltip } from "antd";

import { FC } from "react";
import { ISuggestion } from "@defs/suggestion";
import { IUser } from "@defs/user";
import styles from "./AvatarUser.module.scss";

interface AvatarUserProps extends Pick<AvatarProps, "size"> {
  user?: IUser | ISuggestion | null;
  tooltip?: boolean;
}

const AvatarUser: FC<AvatarUserProps> = ({
  size = "default",
  tooltip = false,
  user,
}) => {
  if (!user) {
    return (
      <Avatar size={size} className={styles.Avatar}>
        ?
      </Avatar>
    );
  }

  const avatar = (
    <Avatar
      size={size}
      className={styles.Avatar}
      src={user.avatar || undefined}
    >
      {user.avatar_name}
    </Avatar>
  );

  return tooltip ? (
    <Tooltip destroyTooltipOnHide title={user.name}>
      {avatar}
    </Tooltip>
  ) : (
    avatar
  );
};

export default AvatarUser;
